import { useEffect, useState } from "react";
import Slider from "react-slick";
import servicosImagens from "../../servicos/servicos-imagens";
import servicosProduto from "../../servicos/servicos-produto";
import { Link } from "react-router-dom";
import { basePath } from "../../utils/baseUrl";

function CarrosselHome(props) {
    const [produtos, setProdutos] = useState([]);
    const [imagens, setImagens] = useState([]);
    const [imagensCarrossel, setImagensCarrossel] = useState([]);


    useEffect(() => {
        servicosProduto.listarTodosCategoria2().then(response => {
            let aux = []
            if (response.status === 200) {
                for (const produto of response.data) {
                    let contem = false;
                    for (const iterator of aux) {
                        if (produto.nome === iterator.nome) {
                            contem = true;
                        }
                    }
                    if (contem === false) {
                        if (aux.length < 26) {
                            aux.push(produto)
                        }
                    }
                }
                setProdutos(aux)
            }
        }).catch(e => {
            console.log(e);
        })
    }, []);

    useEffect(() => {
        servicosImagens.listarTodas().then(response => {
            if (response.status === 200) {
                setImagens(response.data)
            } else {
                console.log('não foi possível obter as imagens dos produtos');
            }
        }).catch(e => {
            console.log(e);
        })
    }, []);

    useEffect(() => {
        let aux = [];
        for (const produto of produtos) {

            for (const iterator of imagens) {
                if (produto.id_produto === iterator.id_produto) {
                    aux.push(iterator)
                }
            }
        }
        const filteredArray = aux.filter((obj, index, self) =>
            index === self.findIndex((o) => o.Produto[0].nome === obj.Produto[0].nome)
        );
        setImagensCarrossel(filteredArray);
    }, [produtos, imagens]);



    const settings = {
        dots: true,
        infinite: true,
        speed: 1000,
        slidesToShow: 4,
        slidesToScroll: 3,
        autoplay: true,
        autoplaySpeed: 4000,
        width: 1000,
        responsive: [
            
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    dots: true,
                    infinite: true,
                    autoplay: true,
                    autoplaySpeed: 4000,
                    centerPadding: "0px",
                    width: "90vw",
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    dots: true,
                    infinite: true,
                    autoplay: true,
                    autoplaySpeed: 4000,
                    centerPadding: "0px",
                    width: "80vw",
                },
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    dots: true,
                    infinite: true,
                    autoplay: true,
                    autoplaySpeed: 4000,
                    centerPadding: "0px",
                    width: "80vw",
                },
            },
            {
                breakpoint: 1600,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                    dots: true,
                    infinite: true,
                    autoplay: true,
                    autoplaySpeed: 4000,
                    centerPadding: "0px",
                    width: "95vw",
                },
            },
        ],
    };
    
    return (
        <>
            <div className="carrossel-home mt-5">
                <Slider {...settings} >
                    {imagensCarrossel.map((produto) => {
                        if (produto.filename) {
                            return (
                                <Link key={produto.filename} to={"/CardProducao"} state={{ produto }} >
                                    <div className="card d-flex justify-content-center align-items-center border-0 " style={{ width: props.tamano || 330, height: props.tamanho || 300, backgroundColor: '#f7f2ff' }}>
                                        <img src={`${basePath}/${produto.filename}`} style={{ width: props.tamanho || 300, height: props.tamanho || 250 }} className="card-img-top" alt="..." />
                                        <div className="card-body">
                                            <p className="card-text">{produto.Produto[0].nome}</p>
                                        </div>
                                    </div>
                                </Link>
                            );
                        } else {
                            return "";
                        }
                    })}
                </Slider>
            </div>
        </>
    );
}

export default CarrosselHome;